export class CoordinateDiagnosis {
  public externalPowerSupply;
  public transmissionTimeBetweenCoordinates;
  public isRunning;
  public accessories;
  public canParams;
  public peripheralEvents;
  public coordinateData;
  public rpmAccessory;
  public panicAccessory;
  public rpm;
  public fuelFlow;
  public brakeStatus;
  public engineBrake;
  public engineFailure;
  public engineTemperature;
  public fuelLevel;
  public hodometer;
  public secondaryHodometer;
  public totalEngineHour;
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/model/coordinate-diagnosis.ts